import React, { useState } from 'react';
import { authClient } from '../lib/authClient';

// "Send it again" for the confirm-your-email link. The answer is the same whether or not the
// address has an unconfirmed account, so it can't be used to find out who's registered.
export default function ResendVerification({ email, label = 'Send it again' }) {
  const [state, setState] = useState('idle');   // idle | sending | sent | limited | failed

  const resend = async () => {
    setState('sending');
    try {
      const { error } = await authClient.sendVerificationEmail({ email, callbackURL: '/email-verified' });
      setState(error?.status === 429 ? 'limited' : error ? 'failed' : 'sent');
    } catch {
      setState('failed');
    }
  };

  const message = {
    sent: "Sent. Check your spam folder if it hasn't arrived in a few minutes.",
    limited: 'Too many attempts, try again in a few minutes.',
    failed: 'Something went wrong. Please try again.',
  }[state];

  return (
    <div style={{ fontSize: 14 }}>
      <button
        type="button"
        onClick={resend}
        disabled={state === 'sending'}
        style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #667eea', background: '#fff', color: '#667eea', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
      >
        {state === 'sending' ? 'Sending…' : label}
      </button>
      {message && <p style={{ margin: '8px 0 0', color: state === 'sent' ? '#1b5e20' : '#dc3545' }}>{message}</p>}
    </div>
  );
}
